import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFileText, FiMail, FiPhone, FiMapPin, FiUser } = FiIcons;

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8"
        >
          <div className="flex items-center mb-8">
            <SafeIcon icon={FiFileText} className="text-red-500 text-3xl mr-4" />
            <h1 className="text-4xl font-bold text-gray-900">Impressum</h1>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="font-semibold text-gray-900 text-lg mb-4">Nadine Rau u. Mike Trepte GbR</p>
                <div className="flex items-center mb-3">
                  <SafeIcon icon={FiMapPin} className="text-red-500 mr-3" />
                  <div>
                    <p className="text-gray-700">Bettenhäuserstr. 1</p>
                    <p className="text-gray-700">34123 Kassel</p>
                    <p className="text-gray-700">Deutschland</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Geschäftsführer</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="flex items-center">
                  <SafeIcon icon={FiUser} className="text-red-500 mr-3" />
                  <p className="text-gray-700">Nadine Rau, Mike Trepte</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 font-semibold">Mike Trepte</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Kontakt</h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <div className="flex items-center">
                  <SafeIcon icon={FiPhone} className="text-red-500 mr-3" />
                  <span className="text-gray-700">0561 / 43027276</span>
                </div>
                <div className="flex items-center">
                  <SafeIcon icon={FiMail} className="text-red-500 mr-3" />
                  <a 
                    href="mailto:nadine.rau@smarte-buchhaltung.online" 
                    className="text-red-500 hover:text-red-600"
                  >
                    nadine.rau@smarte-buchhaltung.online
                  </a>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Umsatzsteuer-ID</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  <span className="font-semibold">Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</span>
                  <br />
                  DE338605405
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Redaktionell verantwortlich</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 font-semibold mb-2">Mike Trepte</p>
                <div className="flex items-center">
                  <SafeIcon icon={FiMapPin} className="text-red-500 mr-3" />
                  <div>
                    <p className="text-gray-700">Bettenhäuserstr. 1</p>
                    <p className="text-gray-700">34123 Kassel</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8 bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">Haftungsausschluss</h3>
              <p className="text-blue-800 text-sm leading-relaxed">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Impressum;